"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

var _NavBar = require("./NavBar");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Shade = _styledComponents.default.div.withConfig({
  displayName: "Shade",
  componentId: "x0j3df-0"
})(["position:absolute;z-index:2;right:0;bottom:0;left:0;top:56px;min-height:calc(100vh - 56px);background:transparent;backdrop-filter:none;"]);

var Nav = _styledComponents.default.div.withConfig({
  displayName: "Nav",
  componentId: "x0j3df-1"
})(["position:relative;nav{position:absolute;z-index:3;width:322px;right:-145px;top:53px;visibility:", ";background:", ";overflow:auto;height:auto;max-height:calc(100vh - 56px);border-radius:4px;border:1px solid #d8d8d8;box-shadow:0 4px 12px 1px ", ";ul li:last-child{border-bottom:0;}}"], function (_ref) {
  var open = _ref.open;
  return open ? "visible" : "hidden";
}, (0, _helpers.color)('white'), (0, _helpers.colorToAlpha)('black', 0.1));

var SubNav = function SubNav(_ref2) {
  var children = _ref2.children,
      Trigger = _ref2.trigger,
      className = _ref2.className,
      onOpen = _ref2.onOpen;

  var _useContext = (0, _react.useContext)(_NavBar.NavBarContext),
      state = _useContext.state,
      toggleMenu = _useContext.toggleMenu;

  var open = state.subnav.open;

  var toggleMe = function toggleMe() {
    var isOpen = toggleMenu('subnav');
    isOpen && onOpen && onOpen();
  };

  return _react.default.createElement(_react.default.Fragment, null, open && _react.default.createElement(Shade, {
    onClick: toggleMe
  }), _react.default.createElement(Nav, {
    open: open,
    className: className
  }, _react.default.createElement(Trigger, {
    open: open,
    onClick: toggleMe
  }), children));
};

var _default = SubNav;
exports.default = _default;